@import 'https://cdn.jsdelivr.net/npm/instantsearch.css@8.11.0/themes/reset-min.css';

.wrapper {
  composes: container from global;
  
  grid-auto-rows: min-content;
  
  &#{&} {
    gap: var(--g-gap);
  }
  
  &:not(&Overlay) {
    margin-top: calc(var(--g-gap) * -1);
  }

  &Overlay {
    background: white;
    overflow: auto;
    position: absolute;
    z-index: 999;
    width: 100%;
    height: calc(100vh - var(--header-height));
  }

  > div:empty {
    display: none;
  }
}

.searchBox {
  pointer-events: none;
  font-size: 1.35em;
  transition:
  font-size var(--header-transition),
  padding-bottom var(--header-transition);

  @at-root :root:has(:global(.header.hidden)) & {
    font-size: 1em;
  }

  &Form {
    container-type: inline-size;
    backdrop-filter: blur(5px);
    background: rgba(white, 0.9);
    border: 1px solid #f2f2f4;
    box-shadow: 0 0 14px 3px rgba(0, 0, 0, 0.05);
    display: grid;
    grid-auto-columns: min-content;
    grid-auto-flow: column;
    grid-template-columns: 1fr;
    pointer-events: initial;

    &::after {
      content: '';
      display: block;
      width: 0.25em;
    }
  }

  &Input,
  &Button {
    grid-row: 1;
  }

  &Input {
    background: transparent;
    border: none;
    font: inherit;
    min-width: 100%;
    padding: 0.732em 1.2em;
    margin-right: calc(100% - 100cqw);
    padding-right: calc(100cqw - 100%);
  }

  &Button {
    align-self: center;
    padding: 0.35em;

    & &Icon {
      display: block;
      height: 1em;
      width: 1em;

      &Close {
        transform: scale(0.9);
      }
    }
  }

  .wrapperOverlay & {
    @container scroll-state(stuck: top) {
      font-size: 1em;
    }
  }

  :has(> &) {
    --header-transition: var(--header-transition-duration-out) var(--header-transition-delay-out);
    --top: calc(var(--g-gap) * 0.5);

    margin: 0;
    padding-top:var(--top);
    min-height: calc(4.1em + var(--top));
    position: relative;
    z-index: 2;
    container-type: scroll-state;
    position: sticky;
    top: 0;

    .wrapper:not(.wrapperOverlay) & {
      // top: var(--top);
      transition: top var(--header-transition),
      transform var(--header-transition);

      @at-root :root:has(:global(.header):not(:global(.hidden))) & {
        --header-transition: var(--header-transition-duration-in) 0s;

        top: calc(var(--header-height));// + var(--top));
      }
    }

    .wrapperOverlay & {
      --header-transition: var(--header-transition-duration-out) 0s;
    }

    // @at-root :root:has(:global(.header.hidden)) & {
    //   transform: translateY(calc(-100% - var(--top)));
    // }
  }
}

.collectionSelect {
  container-type: scroll-state;
  display: flex;
  flex-wrap: nowrap;
  gap: 0.5em;
  overflow-x: auto;
  overscroll-behavior: contain;
  position: relative;
  scrollbar-width: thin;
  scrollbar-gutter: stable;

  &Option {
    background: var(--c-off-white);
    transition: background 0.2s, color 0.2s;
    flex: 0 0 auto;
    padding: 0.5em;
    position: relative;

    &:not(:has(:disabled)) {
      cursor: pointer;
    }

    &:where(:has(:disabled)) {
      opacity: 0.5;
    }

    &:where(:has(:checked)) {
      background: var(--c-goma-grey);
      color: white;
    }

    input, &Input {
      appearance: none;
      inset: 0;
      margin: 0;
      position: absolute;
      z-index: -1;
    }
  }
}

.hits {
  composes: grid from global;
  
  min-height: 50vh;
}

.hitsList {
  composes: grid from global;
  container-type: inline-size;

  &#{&} {
    padding: 0;
  }
}

.hitItem {
  composes: grid from global;
}

.hit {
  composes: card from global;
  composes: card--list from global;

  &Title {
    font-weight: bold;
    margin-bottom: 1em;
  }

  &Subtitle {
    :where(& time + span) {
      font-size: 0.75em;
      margin-left: 0.2em;
      vertical-align: 0.15em;
    }
  }

  &Image {
    max-width: 100%;
    object-fit: cover;
    object-position: center top;
    transition: opacity 0.5s;

    &Wrapper {
      composes: card__image from global;
      background: transparent;
      display: block;
      transition: background 0.5s;

      a:has(> &:first-child:last-child) {
        text-decoration: none;
      }

      picture {
        background-image: var(--background-image);
        background-size: var(--background-size, cover);
        background-position: center;
        background-repeat: no-repeat;
      }
    }

    &Wrapper:has(&Contain) {
      --background-size: contain;
    }

    &Wrapper:has(&Loading) {
      background: linear-gradient(
          90deg,
          white,
          var(--c-goma-grey-disabled),
          white
        )
        0 0/600%;

      :global {
        animation: 2s infinite alternate-reverse backgroundPulse;
      }
    }

    &Loading {
      opacity: 0;
    }

    &#{&}Contain {
      object-fit: contain;
    }

    &Error {
      background: inherit !important;
      line-height: 0 !important;
      width: 100%;
      display: block !important;
      aspect-ratio: unset !important;
      overflow: visible !important;
      position: relative;
      font-size: 0;
      opacity:1;
      transition: none;

      &::before {
        clear: both;
        content: attr(alt);
        display: block;
        font-size: 1rem;
        font-size: clamp(12px, 10cqw, 1rem);
        line-height: 1;
        margin-bottom: -1em;
        padding: 0 0.5em;
        position: relative;
        text-align: center;
        z-index: 3;
      }
    }

    &Wrapper:where(:has(&Error), :not(:has(&))) {
      transition:none;
      align-content: center;
      align-items: center;
      aspect-ratio: 1.7;
      background: var(--c-off-white);
      color: var(--c-goma-grey);
      color: color-mix(in srgb, var(--c-goma-grey), var(--c-off-white) 25%);
      container-type: inline-size;
      display: grid !important;
      grid-auto-rows: min-content;
      justify-content: stretch;
      overflow: hidden;
      position: relative;
      text-align: center;
      z-index: 0;

      :is(:global(.card--list) picture) {
        aspect-ratio: unset;
      }

      &::before {
        aspect-ratio: 1;
        background: currentColor;
        content: '';
        display: block;
        mask-image: url('data-url:../assets/svgs/image.svg');
        mask-repeat: no-repeat;
        mask-position: top center;
        margin: auto;
        position: relative;
        width: 25cqmin;
        max-width: 4em;
        z-index: 3;
      }

      &::after {
        content: '';
        inset: 0;
        background: inherit;
        z-index: 2;
        position: absolute;
      }
    }
  }

  &:has(:global(.ais-Snippet):first-child:last-child:empty) {
    --image-row-span: 1;
  }

  @at-root :has(> :global(.ais-Snippet):first-child:last-child:empty) {
    display: none;
  }
}

.highlight {
  :is(:global(.heading-lg), :global(.heading-md)) & {
    &,
    span {
      display: inline;
      font-weight: inherit;
    }
  }
}

.showMore, .showPrevious {
  composes: button from global;

  margin: auto;

  &:disabled {
    display: none;
  }
}

.stats {
  font-weight: 800;
  margin: calc(var(--g-gap) * -0.3) 0;
}
